import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  title: {
    padding: theme.spacing(3, 0, 2, 0),
  },
}));

export default useStyles;
